module.exports = __webpack_public_path__ + "static/media/p079_keylog.95c9d500.txt";